import { CaseColumn } from "../caseColumns"
import { CalculatedValueAddToDate, CalculatedValueNumerical, Field } from "../field"
import { NewValueSetting } from "../rule"

export interface NewValueSelectorProps {
	value: string | null
	dynamicValue: boolean
	allCaseFieldColumns: CaseColumn[]
	excludeInactiveUsers: boolean
	hideTimeSpentForUserRole: boolean
}

export interface NewValueSelectorPropsForField {
	value: CaseColumn | null
	selectableFields: CaseColumn[]
}

export interface NewValueSelectorPropsForExpression {
	value: CalculatedValueNumerical | CalculatedValueAddToDate | null
	fieldOptions: Field[]
	closeOnSelect: boolean
}

export interface NewValueSettingOption {
	key: NewValueSetting
	label: string
}

export const NewValueSettingLabels = {
	Manual: "Manual Entry",
	Field: "From Field",
	Expression: "From Expression"
}

export const NewValueSettingOptions : NewValueSettingOption[] = [
	{
		key: NewValueSetting.Manual,
		label: NewValueSettingLabels.Manual
	},
	{
		key: NewValueSetting.Field,
		label: NewValueSettingLabels.Field
	},
	{
		key: NewValueSetting.Expression,
		label: NewValueSettingLabels.Expression
	}
]
